// extracted by mini-css-extract-plugin
module.exports = {"container":"GR5a7E_z4UGnJg06ujHLp","headerRow":"_2dA7e27r_ehF55ya9rKm8J","closeButton":"_2E_YlWrB7SG0bqLG9zK0lG","mailButton":"_34OZ_eDxZwsOutJn5px7uJ"};